if (!customElements.get('vto-modal')) {
  customElements.define(
    'vto-modal',
    class VTOModal extends ModalDialog {
      constructor() {
        super();
        this.iframe = this.querySelector('#vto-iframe');
      }

      connectedCallback() {
        if (this.moved) return; // super.connectedCallback() re-triggers this method, but sets moved = true
        super.removeAllOthers();
        super.connectedCallback();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        var currentURL = this.iframe.getAttribute('src');
        var newURL = this.openedBy.getAttribute('data-url');
        if (currentURL !== newURL) {
          this.iframe.setAttribute('src', newURL);
        }
      }
    }
  );
}
